import { render } from "./TournamentResultListDMM.vue?vue&type=template&id=569d72fc&scoped=true"
import script from "./TournamentResultListDMM.vue?vue&type=script&lang=js"
export * from "./TournamentResultListDMM.vue?vue&type=script&lang=js"

import "./TournamentResultListDMM.vue?vue&type=style&index=0&id=569d72fc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-569d72fc"]])

export default __exports__